// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.Error[data-v-69332e49] {\n  border-radius: 50%;\n  width: 250px;\n  height: 250px;\n  background-color: var(--color-primary);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: auto;\n}\n", ""]);
// Exports
module.exports = exports;
